import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { socials } from '../constants/constants'

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-primary text-white py-8">
            <div className="container mx-auto flex flex-wrap justify-between">

                <div className="sm:mb-5 lg:w-1/3 w-full px-4 sm:text-center">
                    <h2 className="text-xl font-bold mb-2">Contact</h2>
                    <p>petik.butor@seznam.cz</p>
                </div>

                <div className="sm:mb-5 lg:w-1/3 w-full px-4 sm:text-center">
                    <h2 className="text-xl font-bold mb-2">Socials</h2>
                    <a href={socials.github.link} target='_blank' rel="noreferrer" className='flex flex-row sm:justify-center gap-2'>
                        <FontAwesomeIcon icon={faGithub} className='text-3xl' />
                        <p>Github</p>
                    </a>
                    <a href={socials.linkedin.link} target='_blank' rel="noreferrer" className='flex flex-row items-center gap-2 mt-2'>
                        <FontAwesomeIcon icon={faLinkedin} className='text-3xl' />
                        <p>Linkedin</p>
                    </a>
                </div>

                <div className="sm:mb-5 lg:w-1/3 w-full px-4 sm:text-center">
                    <h2 className="text-xl font-bold mb-2">Image credits</h2>
                    <div className='text-xs'>
                        <a href="https://www.freepik.com/free-vector/neon-synthwave-border-dark-purple-social-story-template-vector_34371268.htm#query=website%20background&position=6&from_view=search&track=ais&uuid=18439369-a20a-4ea4-8422-24d31774f55b">Image by rawpixel.com</a> on Freepik
                    </div>
                </div>

            </div>
            <hr class="my-5 w-[70%] h-[1px] mx-auto bg-gray-600 border-0 rounded md:my-10"></hr>
            <div className="mt-8 text-center">
                <p className=''>&copy; Copyright {currentYear} peterb.cz</p>
                <p>All Rights Reserved</p>
            </div>
        </footer>
    );
};

export default Footer;